import type { TBotConfig } from '~entities/bot';

const apiBase = process.env.PUBLIC_API ?? 'https://api.ifriend.ai';

export const getAllBots = async (params?: RequestInit) => {
	const response = await fetch(`${apiBase}/ai/configuration/bots`, {
		...params,
		next: { ...params?.next, tags: ['all-bots'] },
	});

	if (!response.ok) {
		throw new Error(`Error fetching all bots: ${response.status}`);
	}

	const data = (await response.json()) as Record<string, TBotConfig>;

	return { data, timestamp: response.headers.get('date') };
};
